<template>
  <div class="join-page">
    <div class="toolbar">
      <el-button size="small" class="btn btn-back" icon="el-icon-arrow-left" @click="toBack" round>返回</el-button>
      <!--      <el-button size="small" class="btn btn-close" icon="el-icon-close" @click="doClose" circle></el-button>-->
    </div>
    <div class="content">
      <h1 class="home-title">账户注册</h1>
      <p class="home-description">我们将在企业中为您提供优质服务</p>
      <hr>
      <div class="new-comp-wrap">
        <el-form :model="fm" ref="registerFm" center :rules="rules">
          <el-form-item prop="name">
            <el-input prefix-icon="el-icon-school" v-model="fm.name" placeholder="请输入您的公司名称"></el-input>
          </el-form-item>
          <el-form-item prop="trueName">
            <el-input prefix-icon="el-icon-user-solid" v-model="fm.trueName" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input prefix-icon="el-icon-key" v-model="fm.password"  type="password" placeholder="请输入用户密码"></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input prefix-icon="el-icon-mobile" type="text" maxlength="11" show-word-limit :clearable="true" v-model="fm.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input prefix-icon="el-icon-message" type="text" v-model="fm.code" placeholder="请输入短信验证码" :clearable="true">
              <el-button slot="append" @click="fetchCaptcha" :disabled="disabled">{{ text }}</el-button >
            </el-input>
          </el-form-item>
        </el-form>
        <div style="width: 100%; margin-top: 20px">
          <el-button type="primary" style="width: 100%" @click="doRegister">注册</el-button>
        </div>
      </div>
      <div class="register-wrap" style="margin-top: 10px;">
        <div><span>已有帐号?</span><el-link type="primary" @click="toLogin">去登录</el-link></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchVerify } from '@/api/system/user'
import { register } from '@/api/manage/company'
import sendVerifyCode from "@mixins/SendVerifyCode";

export default {
  name: 'register-page',
  data() {
    return {
      fm: {
        code:""
      },
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        trueName: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { required: true, message: '请输入正确的电话号码', trigger: 'blur',pattern:/^1(3|4|5|7|8|9|6)\d{9}$/ },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }, // 表单校验
      disabled: false,
      text: "获取验证码"
    }
  },
  mixins: [sendVerifyCode],
  methods: {
    doRegister(){
      this.$refs['registerFm'].validate((valid) => {
        if (valid) {
          let info = this.fm
          register(info).then(res =>{
            if (res.data.code == 200){
              this.$message.success('注册完毕，审核通过后，将会以短信方式通知您！')
              this.$router.replace('/login')
            }else{
              this.$message.error(res.data.message)

            }
          })
        }
      })
    },
    toBack() {
      this.$router.go(-1)
    },
    async fetchCaptcha() {
      let that = this
      this.$refs["registerFm"].validateField("phone",flag => {
        if(flag){
          console.log(flag,'失败！！！')
        }else{
          that.sendCode();
          fetchVerify(this.fm.phone,'register').then(resp => {
            this.fm.code = ''
          })
        }
      })
    },
    toLogin() {
      this.$router.push('/login')
    },
  }
}
</script>

<style lang="scss">
.join-page {
  height: 100vh;
  width: 100%;
  font-family:-apple-system,Noto Sans,Helvetica Neue,Helvetica,Nimbus Sans L,Arial,Liberation Sans,PingFang SC,Hiragino Sans GB,Noto Sans CJK SC,Source Han Sans SC,Source Han Sans CN,Microsoft YaHei,Wenquanyi Micro Hei,WenQuanYi Zen Hei,ST Heiti,SimHei,WenQuanYi Zen Hei Sharp,sans-serif;

  .toolbar{
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    padding: 0 50px;

    .btn{
      color: #595959;
      background: #e5e5e5;
      border:none;
      &:hover{
        border:none;
        color: #262626;
        background: #d9d9d9;
      }
    }
  }
  .content{
    background-color: #fff;
    width: 330px;
    margin: 50px auto 20px;
    min-height: 460px;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding-left: 50px;
    padding-right: 50px;


    .home-title{
      font-size: 36px;
      font-weight: 400;
      margin:10px 0;
    }

    .home-description{
      margin:10px 0 10px;
      line-height: 24px;
      height: 24px;
      font-size: 18px;
      color: #8c8c8c;
      box-sizing: border-box;
      text-rendering: optimizeLegibility;
      font-weight: lighter;
    }

    hr{
      border: solid #e5e5e5;
      border-width: 1px 0 0 0;
      margin-bottom:24px;
      background: #f0f0f0;
    }

    .org-group{
      list-style: none;

      .org-item{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;

        .org-item-img{
          width:40px;
          height:40px;
          border-radius: 4px;
          margin-right: 15px;
        }

        .org-item-content{
          .org-item-name{
            &:hover{
              color: #00a0e9;
            }

            width:395px;
            font-size: 14px;
            flex: 0 1 auto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .org-item-desc{
            color: #bfbfbf;
            font-size: 12px;
            line-height: 12px
          }
        }

      }

      .org-item-create{
        .org-item-name{
          line-height: 20px;
          color: #8c8c8c;
          margin-bottom: 4px
        }
        .org-item-img{
          text-align: center;
          line-height: 40px;
          background-color: #f0f0f0;
        }

      }
    }
  }
}

.btn-submit-wrap{
  margin-top: 30px;

  .el-button{
    width:60%;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-weight: 700;
  }
}
</style>
